//import THREE from "three";
import BaseOverlay from "./base-overlay";
import Utils from "../utils";

const MATERIAL_BASIC = new THREE.MeshBasicMaterial({
    color: 0xff00ff,
    morphTargets: true
});

const MATERIAL_BASIC_SKINNED = new THREE.MeshBasicMaterial({
    skinning: true,
    color: 0xff00ff,
    morphTargets: true
});

class RegionOverlay extends BaseOverlay {
    constructor() {
        super();
    }

    /**
     * 
     * @param {THREE.WebGLRenderer} renderer 
     * @param {THREE.Scene} scene 
     * @param {THREE.Camera} camera 
     * @param {*} param3 
     */
    render(renderer, scene, camera, { object }) {
        if (!object || !object.isMesh || !object.material || !object.geometry) {
            console.error("Someone passed non-mesh object to renderer.");
            return;
        }

        const autoClear = renderer.autoClear;
        renderer.autoClear = false;

        renderer.setRenderTarget(this._rt);
        renderer.clear();

        const gl = renderer.getContext();
        if (!Utils.queryParams.has("blob_stencil_disabled")) gl.enable(gl.STENCIL_TEST);

        const paintRegion = object => {
            if (object.isMesh && object.subRegions && object.subRegions.children.length > 0) {
                /**
                 * @type {THREE.Scene}
                 */
                const sub = object.subRegions;
                sub.matrix.copy(object.matrix);
                sub.matrixWorld.copy(object.matrixWorld);
                const dMat = sub.overrideMaterial;
                sub.overrideMaterial = null;
                renderer.render(sub, camera, this._rt);
                sub.overrideMaterial = dMat;
            }
        };

        // const depthBuffer = renderer.state.buffers.depth;
        // const colorBuffer = renderer.state.buffers.color;

        // colorBuffer.setLocked(true);
        gl.stencilFunc(gl.ALWAYS, 3, 0xff)
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE);
        // gl.colorMask(false, false, false, false);
        if (object.material instanceof Array) {
            for (let group of object.geometry.groups) {
                let material = object.material[group.materialIndex];
                renderer.renderBufferDirect(camera, null, object.geometry, material.skinning ? MATERIAL_BASIC_SKINNED : MATERIAL_BASIC, object, group);
            }
        } else {
            renderer.renderBufferDirect(camera, null, object.geometry, object.material.skinning ? MATERIAL_BASIC_SKINNED : MATERIAL_BASIC, object, null);
        }
        // renderer.render(object, camera, this._rt);
        // renderer.setRenderTarget(this._rt);
        // colorBuffer.setLocked(false);
        // gl.colorMask(true, true, true, true);

        // depthBuffer.setLocked(true);
        // gl.disable(gl.DEPTH_TEST);
        gl.stencilFunc(gl.EQUAL, 3, 0xff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clear(gl.COLOR_BUFFER_BIT);
        paintRegion(object);
        // gl.enable(gl.DEPTH_TEST);
        // depthBuffer.setLocked(false);

        gl.disable(gl.STENCIL_TEST);

        // depthBuffer.setLocked(false);
        // colorBuffer.setLocked(false);

        renderer.autoClear = autoClear;
    }
}

export default RegionOverlay
export { RegionOverlay };